import React from "react";
import { Navigate } from "react-router-dom";

import { Error } from "@components/common";

export const globalRoutes = [
  {
    element: <Error />,
    path: "error",
  },
  {
    element: <Navigate to="/error" replace />,
    path: "*",
  },
];
